import { createAction, props } from '@ngrx/store';
import { User } from '@surface-elements/users/domain';
import { ApiKey, CreateApiKeyResponse, UserToken } from './admin-users.state';

export const loadUsers = createAction('[AdminUsers] Load');

export const loadUsersSuccess = createAction(
  '[AdminUsers] Load Success',
  props<{ users: User[] }>(),
);

export const loadUsersFailure = createAction(
  '[AdminUsers] Load Failure',
  props<{ error: string }>(),
);

export const updateRoles = createAction(
  '[AdminUsers] Update Roles',
  props<{ userId: string; roles: string[] }>(),
);

export const updateRolesSuccess = createAction(
  '[AdminUsers] Update Roles Success',
  props<{ userId: string; roles: string[] }>(),
);

export const updateRolesFailure = createAction(
  '[AdminUsers] Update Roles Failure',
  props<{ error: string }>(),
);

// API Key actions (SEOMS-349)
export const loadApiKeys = createAction('[AdminUsers] Load API Keys');

export const loadApiKeysSuccess = createAction(
  '[AdminUsers] Load API Keys Success',
  props<{ apiKeys: ApiKey[] }>(),
);

export const loadApiKeysFailure = createAction(
  '[AdminUsers] Load API Keys Failure',
  props<{ error: string }>(),
);

export const createApiKey = createAction(
  '[AdminUsers] Create API Key',
  props<{ name: string; userId: string }>(),
);

export const createApiKeySuccess = createAction(
  '[AdminUsers] Create API Key Success',
  props<{ response: CreateApiKeyResponse }>(),
);

export const createApiKeyFailure = createAction(
  '[AdminUsers] Create API Key Failure',
  props<{ error: string }>(),
);

export const revokeApiKey = createAction(
  '[AdminUsers] Revoke API Key',
  props<{ keyId: string }>(),
);

export const revokeApiKeySuccess = createAction(
  '[AdminUsers] Revoke API Key Success',
  props<{ keyId: string }>(),
);

export const revokeApiKeyFailure = createAction(
  '[AdminUsers] Revoke API Key Failure',
  props<{ error: string }>(),
);

export const revokeUserTokens = createAction(
  '[AdminUsers] Revoke User Tokens',
  props<{ userId: string }>(),
);

export const revokeUserTokensSuccess = createAction(
  '[AdminUsers] Revoke User Tokens Success',
  props<{ userId: string; revokedCount: number }>(),
);

export const revokeUserTokensFailure = createAction(
  '[AdminUsers] Revoke User Tokens Failure',
  props<{ error: string }>(),
);

export const clearCreatedApiKey = createAction(
  '[AdminUsers] Clear Created API Key',
);

// User token actions (SEOMS-349 inline expand)
export const loadUserTokens = createAction(
  '[AdminUsers] Load User Tokens',
  props<{ userId: string }>(),
);

export const loadUserTokensSuccess = createAction(
  '[AdminUsers] Load User Tokens Success',
  props<{ userId: string; tokens: UserToken[]; activeCount: number }>(),
);

export const loadUserTokensFailure = createAction(
  '[AdminUsers] Load User Tokens Failure',
  props<{ error: string }>(),
);

export const collapseUserTokens = createAction(
  '[AdminUsers] Collapse User Tokens',
);
